import React from 'react';
import './footer.css';
const Footer = () => {
  return (
    <footer className="footer">
      {/* <div className="container py-4 py-lg-5"> */}
        <hr />
        {/* <div className="d-flex flex-column align-items-center pt-3"> */}
          <p className="footer-text mb-0">
            Copyright © Niox developers 2022
          </p>
        {/* </div> */}
      {/* </div> */}
    </footer>
  );
};

export default Footer;
